// Age popup
;(function(){
  
  var popup = document.querySelector('.js-age-popup');
  var ageCookie = sessionStorage.getItem('age_cookie');
  var pageContainer = document.querySelector('.inner-body');
  
  var lockBody = function() {
    if ( pageContainer ) {
      pageContainer.style.pointerEvents = 'none';
      pageContainer.style.filter = 'blur(2px)';
      pageContainer.style.transition = 'all .2s ease';
    }
    
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = 0;
  };
  
  var unlockBody = function() {
    if ( pageContainer ) {
      pageContainer.style.pointerEvents = 'auto';
      pageContainer.style.filter = null;
    }
    
    document.body.style.position = 'relative';
    document.body.style.top = null;
  };
  
  if ( popup && !ageCookie ) {
    var accept = popup.querySelector('.js-accept-age');
    var decline = popup.querySelector('.js-decline-age');
    var redirectURL = decline?.dataset?.redirectUrl || '/';
    
    popup.classList.add('open');
    lockBody();
    
    if ( accept ) {
      accept.addEventListener('click', function() {
        popup.classList.remove('open');
        unlockBody();
        sessionStorage.setItem("age_cookie", "true");
      });
    }

    if ( decline ) {
      decline.addEventListener('click', function() {
        window.location.href = redirectURL ?? '/404';
      });
    }
  }
  
})();

